<template>
  <section :class="{ 'section-builder-hover-button-row': true }">
    <GeneralTheme :theme="configuration">
      <div
        :class="{
          'mx-auto max-w-1920px lg:w-full': true,
        }"
      >
        <PortableText
          v-if="heading?.standardPortableText"
          :portable-data="heading.standardPortableText"
        />
        <HoverButtonRow
          v-if="hoverButtonRow"
          v-bind="hoverButtonRow"
          :buttons-block-width="buttonsBlockWidth"
          :buttons-block-alignment="buttonsBlockAlignment"
          :buttons-block-theme="buttonsBlockTheme"
          :image-block="imageBlock"
        />
      </div>
    </GeneralTheme>
  </section>
</template>

<script setup lang="ts">
import HoverButtonRow from './HoverButtonRow.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import type { SectionBuilderHoverButtonRow } from '~/sanity/types';

defineProps<SectionBuilderHoverButtonRow>();
</script>

<style lang="scss" scoped>
.section-builder-hover-button-row .background-image-wrapper {
  background-size: contain !important;
  background-position: bottom right !important;
  @media (max-width: 1024px) {
    background-image: none !important;
  }
}
</style>
